import { computed, observable } from 'mobx';
import { IImageBlockStyles, Alignment } from '~/types/block-styles.types';
import { IImage } from '~/types/model.types';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import { IImageBlockResponse } from '~/types/server.types';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';

export class CXImageBlock extends CXBaseBlock {
    type: 'image_block';

    constructor(
        block: IImageBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    @observable image: IImage;
    @observable styles: IImageBlockStyles;

    @computed
    get isStretched() {
        return this.styles.alignment === Alignment.STRETCH;
    }

    @computed
    get isImagePlaceholder() {
        return !this.image || (this.image && !this.image.url);
    }
}
